/** Iter 632 — customer wizard · brand header: till code or store bar (JSX moved verbatim from EngageSessionPanel.jsx). */
import React from "react";
import { Clock, Receipt } from "lucide-react";

export default function StoreHeader({ w, brandColor, textOnBrand }) {
  const { s, countdown, wizardStep, pointsOnly } = w;
  /* Iter-357 §1 — the short code's ONLY job is pairing: show it while
     waiting for the bill, then REPLACE it with a plain store header.
     No code, no timer from the moment the bill lands. */
  if (s.bill_amount == null) {
    return (
      <div className="p-5 text-center" style={{ backgroundColor: brandColor, color: textOnBrand }}>
        <div className="text-[11px] font-bold uppercase tracking-[0.18em] opacity-85">
          Show this code at the till
        </div>
        <div className="mt-1 font-display text-5xl font-black tracking-widest" data-testid="engage-session-code">
          {s.short_code || "—"}
        </div>
        <div className="mt-2 flex items-center justify-center gap-3 text-xs font-bold">
          {typeof s.discount_percent === "number" && s.discount_percent > 0 && (
            <span className="rounded-full bg-white/15 border border-white/25 px-2.5 py-0.5" data-testid="engage-session-discount">
              {Number(s.discount_percent).toFixed(0)}% off
            </span>
          )}
          {countdown.label && (
            <span className="inline-flex items-center gap-1 opacity-85" data-testid="engage-session-timer">
              <Clock className="w-3.5 h-3.5" /> {countdown.label}
            </span>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className="p-5 text-center" style={{ backgroundColor: brandColor, color: textOnBrand }} data-testid="engage-store-header">
      <div className="flex items-center justify-center gap-2 font-display text-xl font-black">
        <Receipt className="w-5 h-5" /> {s.vendor?.business_name || "Your bill"}
      </div>
      <div className="mt-1 text-xs font-semibold opacity-85">
        {wizardStep === 2
          ? "Share a photo to unlock your discount"
          : wizardStep === 3
          ? "Post it and submit for approval"
          : s.bill_confirmed
          ? pointsOnly
            ? "Product Payment — pay with points (5% off)"
            : "Ready to pay"
          : "Bill received — check it and confirm."}
      </div>
    </div>
  );
}
